import { connect } from 'react-redux'
import React from 'react'
import ReportView from '../app/report/Report'
import Logo from "../assets/newblacklogo.png"

const Report = ({ params, location }) => (
  <div style={{minHeight: '100vh'}}>
    <div className="app-nav">
      <nav className="navbar navbar-full">
        <a href="/" className="nav-btn" key="logo">
          <img className="logo" src={Logo} role="presentation" />
        </a>
      </nav>
    </div>
    <ReportView viewParams={ params } shortcode={ params.shortcode} query={ location.query } />
  </div>
)

export default connect()(Report)
